var scope_0 = require('/vercel/34daa973/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/703423b7edb83b31c9af8f6c1a420869.js').default;export default
        Object.assign({}, scope_0 )
    